import React, { useRef, useState } from "react";
import { Icon } from "../../shared/icon/Icon";
import styles from "./Chat.module.css";
import { ChatMessage } from "./ChatMessage";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";
import { useChatBox } from "../../../hooks/useChatBox";

interface ChatProps {
  isShareLayout: boolean;
}

export const ChatBox: React.FC<ChatProps> = ({ isShareLayout }) => {
  const { messages, showChat } = useSelector((s: RootState) => s.chatMessages);
  const [formElement, setFormElement] = useState<HTMLFormElement>(null);
  const msgArray = [...messages]; //needs to be mutable for reverse()
  const [textAreaElement, setTextAreaElement] =
    useState<HTMLTextAreaElement>(null);
  const messagesEndRef = useRef(null);
  const { onKeyDown, onSubmit, onChange, handleScroll, newMessage } =
    useChatBox(formElement, messagesEndRef, textAreaElement);

  return (
    <div
      className={`${styles["chat-box"]} ${
        isShareLayout ? styles["share-chat-box"] : ""
      }  `}
    >
      <div
        className={`${styles["list"]} ${
          isShareLayout ? styles["thin"] : showChat ? styles["show"] : ""
        }`}
        onScroll={handleScroll}
      >
        <div className={`${styles["inner-list"]}`}>
          <div ref={messagesEndRef} />
          {msgArray.reverse().map((m) => {
            return <ChatMessage key={m.id} message={m} />;
          })}
        </div>
      </div>
      <hr />
      <div className={`${styles["form-field"]}`}>
        <form
          ref={(ref) => {
            setFormElement(ref);
          }}
          onSubmit={onSubmit}
        >
          <textarea
            className={`${styles["input-field"]} ${
              isShareLayout ? styles["share-input-field"] : ""
            }`}
            id="message"
            rows={2}
            placeholder="type message here..."
            value={newMessage}
            onChange={onChange}
            maxLength={500}
            onKeyDown={onKeyDown}
            ref={(ref) => {
              setTextAreaElement(ref);
            }}
          ></textarea>
          <button
            type="submit"
            className={`${isShareLayout ? styles["none"] : ""}`}
          >
            <Icon id={"chevron-right"} />
          </button>
        </form>
      </div>
    </div>
  );
};
